import { VisualizatorSettings } from "./visualizator-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class SignalCommonSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "id") {
        this.id = settings.id;
      } else if (key == "title") {
        this.title = settings.title;
      } else {
        if (key.length > 0 && key[0] == "_") {
          // special private field
          this[key] = ObjectCreator.shallowCopy(settings[key]);
        } else if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new SignalCommonSettings(this);
  }
}
